import { ArtFeedNavbarSlice } from './artFeedNavbar.types';

export const getDefaultState = (): ArtFeedNavbarSlice => ({
  currentlyOnLocation: {},
  currentlyScrolled: {},
  isOnLocation: false,
  shouldBeScrolled: false,
});
